import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab" }

import { inject } from 'vue'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Tab',
  props: {
    title: {
      type: String,
      default: 'Tab'
    },
    faIcon: {
      type: String,
      default: null
    },
  },
  setup(__props) {

const props = __props;

  const selectedTab = inject('selectedTab')
  
  
  
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ], 512)), [
    [_vShow, _unref(selectedTab) == __props.title]
  ])
}
}

})